import { deleteEquipmentMenu, getEquipmentMenus, OrganizationEquipmentMenuService } from "@/services/admin/equipment-menu/equipmentMenu.services"
import { Equipment } from "@/services/project/equipment/equipment.model"
import { ExclamationCircleOutlined } from "@ant-design/icons"
import { useRequest } from "ahooks"
import { Button, Modal, Space, Table } from "antd"
import { useMemo } from "react"
import { CreateEditMenu } from "./CreateEditMenus"

interface EquipmentMenusProps {
  orgId?: number
}

export function EquipmentMenus(props: EquipmentMenusProps) {
  const { orgId } = props

  const service = useMemo(() => {
    if (orgId) {
      return {
        getEquipmentMenus: () => OrganizationEquipmentMenuService.getEquipmentMenus(orgId),
        deleteEquipmentMenu: (id) => OrganizationEquipmentMenuService.deleteEquipmentMenu(id)
      }
    }
    return {
      getEquipmentMenus: getEquipmentMenus,
      deleteEquipmentMenu: deleteEquipmentMenu
    }
  }, [orgId])

  const { data, loading, refresh } = useRequest(() => service.getEquipmentMenus(), {
    refreshDeps: [service]
  })

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Equipment',
      dataIndex: 'equipment',
      key: 'equipment',
      render: (equipment: Equipment.Base[]) => {
        return equipment.map(item => item.name).join(',')
      }
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (item) => {
        return <Space>
          <Button size="small" onClick={() => {
            CreateEditMenu.show({menu: item, onSuccess: () => {
              refresh()
            }, orgId})
          }}>Edit</Button>
          <Button size="small" danger onClick={() => {
            Modal.confirm({
              icon: <ExclamationCircleOutlined />,
              content: 'Are you sure to delete?',
              onOk: async () => {
                try {
                  await service.deleteEquipmentMenu(item.id)
                  refresh()
                  return true
                } catch (error) {
                  return false
                }
              }
            })
          }}>Delete</Button>
        </Space>
      }
    },
  ]
  
  return <div>
    <div className="actionRow">
      <Button type='primary' onClick={() => {
        CreateEditMenu.show({onSuccess: () => {
          refresh()
        }, orgId})
      }}>Create Palette Container</Button>
    </div>
    <div className="tableContainer mt-2">
      <Table columns={columns} dataSource={data}/>
    </div>
  </div>
}